import React from 'react';
import LocationTemplate from './LocationTemplate';

const KenansvillePage: React.FC = () => {
  return (
    <LocationTemplate
      cityName="Kenansville"
      stateName="North Carolina"
      countyName="Duplin"
      zipCodes={["28349"]}
      latitude={34.9626}
      longitude={-77.9669}
      population={855}
      historicalFact="County seat of Duplin County, established in 1818 and named after Thomas Kenan, an early legislator."
      nearbyTowns={[
        "Warsaw, NC",
        "Rose Hill, NC",
        "Clinton, NC",
        "Beulaville, NC",
        "Pink Hill, NC",
        "Turkey, NC",
        "Mount Olive, NC",
        "Richlands, NC"
      ]}
    />
  );
};

export default KenansvillePage;